module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lPZyV"))).then(() => parcelRequire('1iHdE'));